import { render } from "./AssignementsSubmitted.vue?vue&type=template&id=60a7488c&scoped=true"
import script from "./AssignementsSubmitted.vue?vue&type=script&lang=js"
export * from "./AssignementsSubmitted.vue?vue&type=script&lang=js"

import "./AssignementsSubmitted.vue?vue&type=style&index=0&id=60a7488c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a7488c"]])

export default __exports__